import React from "react";
import OwlCarousel from "react-owl-carousel2";
import api from "../../storage/api";

const Purchases = (props) => {
  const options = {
    loop: false,
    items: 5,
    autoplay: false,
    mouseDrag: false,
    nav: false,
    margin: 30,
    responsive: {
      0: {
        items: 2,
        margin: 15,
      },
      576: {
        items: 3,
        margin: 15,
      },
      768: {
        items: 4,
        margin: 15,
      },
      993: {
        items: 5,
        margin: 15,
      },
      1201: {
        items: 5,
        margin: 30,
      },
    },
  };

  const getDateString = (date) => {
    const purchaseDate = new Date(Date.parse(date));
    const currentDate = new Date();

    if (
      purchaseDate.getFullYear() === currentDate.getFullYear()
    ) {
      if (purchaseDate.getMonth() === currentDate.getMonth()) {
        if (purchaseDate.getDate() === currentDate.getDate()) {
          return `Сегодня в ${purchaseDate.getHours() < 10 ? "0"+purchaseDate.getHours() : purchaseDate.getHours()}:${purchaseDate.getMinutes() < 10 ? "0"+purchaseDate.getMinutes() : purchaseDate.getMinutes()}`;
        } else if (
          purchaseDate.getDate() ===
          currentDate.getDate() - 1
        ) {
          return `Вчера в ${purchaseDate.getHours() < 10 ? "0"+purchaseDate.getHours() : purchaseDate.getHours()}:${purchaseDate.getMinutes() < 10 ? "0"+purchaseDate.getMinutes() : purchaseDate.getMinutes()}`;
        }
      }
    }

    const month = purchaseDate.getMonth() + 1 < 10 ? "0" + (purchaseDate.getMonth() + 1) : purchaseDate.getMonth() + 1;

    return `${purchaseDate.getDate()}.${month}.${purchaseDate.getFullYear()} в в ${purchaseDate.getHours() < 10 ? "0"+purchaseDate.getHours() : purchaseDate.getHours()}:${purchaseDate.getMinutes() < 10 ? "0"+purchaseDate.getMinutes() : purchaseDate.getMinutes()}`;
  };

  return (
    <section className="purchases">
      <div className="container">
        <div className="common-title">
          <h2 className="common-title__h2">
            <span>Последние</span> покупки
          </h2>
          <p className="common-title__subtitle">
            неоценимый вклад в развитие проекта
          </p>
        </div>
        <div className="purchases-carousel">
          {props.purchases.length > 0 && (
            <OwlCarousel
              options={options}
              className="purchases-carousel-body owl-carousel"
            >
              {props.purchases.map((item, index) => {


                return (
                  <div className="purchase" key={index}>
                    <img
                      src={`${api.apiUrl}/engine/face.php?u=${item.nickname}&s=80&v=front`}
                      className="purchase__head"
                      alt={item.nickname}
                    />
                    <h5 className="purchase__nickname">{item.nickname}</h5>
                    {item.status ? (
                      <span className="purchase__status">Выдано</span>
                    ) : (
                      <span className="purchase__status purchase__status_waiting">
                        Ожидаем игрока на сервере
                      </span>
                    )}
                    <div className="purchase-body">
                      <span className="purchase-body__item" title={item.donate}>{item.donate}</span>
                      <span className="purchase-body__date">
                        {getDateString(item.date)}
                      </span>
                    </div>
                  </div>
                );
              })}
            </OwlCarousel>
          )}
        </div>
      </div>
    </section>
  );
};

export default Purchases;
